/*
  Lior Apple layer: shelf behaviour for sections/lior-apple-story.liquid.
  - Paddle buttons scroll by whole cards (RTL aware) and disable at the ends.
  - Cards slide in once, one after another, when the shelf first comes into view.
  Works with several shelves on a page and with the theme editor.
*/
(function () {
  'use strict';

  if (window.__liorShelf) return;
  window.__liorShelf = true;

  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function init(root) {
    if (!root || root.__lasReady) return;
    root.__lasReady = true;

    var track = root.querySelector('[data-las-scroller]');
    var prev = root.querySelector('[data-las-prev]');
    var next = root.querySelector('[data-las-next]');
    if (!track) return;

    function rtl() {
      return getComputedStyle(track).direction === 'rtl';
    }

    function step() {
      var card = track.querySelector('.las-item');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
      var w = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      var fit = Math.max(1, Math.floor((track.clientWidth + gap) / w));
      return w * fit;
    }

    var frame = 0;
    function update() {
      frame = 0;
      var max = track.scrollWidth - track.clientWidth;
      var x = Math.abs(track.scrollLeft);
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= max - 2;
      root.classList.toggle('las-scrollable', max > 2);
    }

    function schedule() {
      if (!frame) frame = requestAnimationFrame(update);
    }

    function go(sign) {
      var dx = sign * step() * (rtl() ? -1 : 1);
      track.scrollBy({ left: dx, behavior: reduce.matches ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    track.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(track);
    update();

    /* First view: slide the cards in (not in the editor, not with reduced motion) */
    if (designMode || reduce.matches || !('IntersectionObserver' in window)) return;
    var r = root.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) return; /* already on screen: leave it be */
    root.classList.add('las-pre');
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          root.classList.add('las-in');
          io.disconnect();
          setTimeout(function () {
            root.classList.remove('las-pre', 'las-in');
          }, 1600);
          break;
        }
      }
    }, { threshold: 0.18 });
    io.observe(root);
  }

  function scan(scope) {
    var list = (scope || document).querySelectorAll('[data-las]');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();
